<!--
  AGB v3.0 (21.08.2026) — Neustrukturierung nach Anwaltsempfehlung:
  Die AGB nennen keine Tarife, Produkte oder Preise mehr. Entgelte stehen im
  Preis- und Leistungsverzeichnis (/entgelte), produktspezifische Regelungen
  in Besonderen Bedingungen je Produkt (für die Safes: /besondere-bedingungen —
  bis 01.09.2026 unter meinvertraut.de/vertragsbedingungen.html). Beides kann geändert werden,
  ohne die AGB anzufassen. Für Altverträge (vor 21.08.2026) gilt die dort
  einbezogene Fassung fort (zuletzt v2.7) — siehe §13 Abs. 4; die Fassung
  liegt in der Git-Historie (Commit 3802bea) und wird auf Anfrage
  bereitgestellt.
-->
<div class="rechtstext">
  <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
  <p class="leise">
    für Dienstleistungen und Softwareprodukte von IT-Service Karsten Fischer (nachfolgend
    „Anbieter" genannt).
  </p>

  <h2>§1 Geltungsbereich und Vertragsgrundlagen</h2>
  <p>
    (1) Diese AGB gelten für alle Verträge zwischen dem Anbieter und seinen Kunden über
    IT-Dienstleistungen (insbesondere Support-, Beratungs- und Vor-Ort-Leistungen) sowie über die
    Nutzung von Softwareprodukten des Anbieters.
  </p>
  <p>
    (2) Die jeweils angebotenen Leistungen und Softwareprodukte sowie die zugehörigen Entgelte
    ergeben sich aus dem vom Anbieter veröffentlichten
    <a href="/entgelte">Preis- und Leistungsverzeichnis</a> in der bei Vertragsschluss gültigen
    Fassung. Der Anbieter kann das Verzeichnis für künftige Vertragsschlüsse jederzeit anpassen,
    Leistungen oder Produkte hinzufügen oder für Neuabschlüsse einstellen; bestehende Verträge
    bleiben davon unberührt.
  </p>
  <p>
    (3) Für einzelne Softwareprodukte gelten ergänzend Besondere Bedingungen (Vertragsergänzungen),
    die dem Kunden vor Vertragsschluss zugänglich gemacht werden. Bei Widersprüchen gilt folgende
    Rangfolge: individuelle Vereinbarung, Besondere Bedingungen des jeweiligen Produkts, das
    Preis- und Leistungsverzeichnis, diese AGB.
  </p>
  <p>
    (4) Abweichende oder ergänzende Geschäftsbedingungen des Kunden werden nicht Vertragsbestandteil,
    es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
  </p>

  <h2>§2 Leistungen</h2>
  <p>
    (1) Der Anbieter erbringt ein IT-Support- und Beratungsangebot zur Unterstützung im digitalen
    Alltag. Zu den angebotenen Leistungen zählen insbesondere: Telefon- und Remote-Support,
    verständliche IT-Beratung und Hilfe zur Selbsthilfe, der Zugang zum Kundenportal (§4),
    Vor-Ort-Leistungen (§5) sowie Softwareprodukte gemäß dem Preis- und Leistungsverzeichnis und den
    jeweiligen Besonderen Bedingungen.
  </p>
  <p>
    (2) Ein Anspruch auf bestimmte Leistungsformen besteht nicht. Insbesondere schuldet der Anbieter
    keine Vor-Ort-Leistungen oder permanente Verfügbarkeit.
  </p>
  <p>
    (3) Der konkrete Leistungsumfang ergibt sich aus dem Preis- und Leistungsverzeichnis, den
    jeweiligen Besonderen Bedingungen sowie ggf. individuellen Vereinbarungen.
  </p>
  <p>
    (4) Der Anbieter schuldet keinen bestimmten Erfolg, sondern ausschließlich die fachgerechte
    Erbringung der vereinbarten Dienstleistung im Rahmen eines Dienstvertrags (§ 611 BGB).
  </p>

  <h2>§3 Leistungsbezogene Abrechnung</h2>
  <p>
    (1) IT-Dienstleistungen werden leistungsbezogen abgerechnet: Entgelte fallen ausschließlich bei
    tatsächlicher Inanspruchnahme an. Es bestehen keine Grundgebühren, Mindestabnahmen oder
    laufenden Zahlungspflichten.
  </p>
  <p>
    (2) Abrechnungseinheit ist die Betreuungseinheit von bis zu 30 Minuten. Die Entgelte je
    Betreuungseinheit für Remote- und Vor-Ort-Leistungen ergeben sich aus dem Preis- und
    Leistungsverzeichnis; dort ist auch ausgewiesen, welche Leistungen (etwa die telefonische
    Erstberatung und Problemanalyse) unentgeltlich sind.
  </p>
  <p>
    (3) Bei überdurchschnittlicher oder missbräuchlicher Inanspruchnahme unentgeltlicher Leistungen
    ist der Anbieter berechtigt, die Leistung einzuschränken oder nur noch entgeltlich anzubieten.
  </p>

  <h2>§4 Kundenportal</h2>
  <p>
    (1) Der Anbieter stellt dem Kunden ein internetbasiertes Kundenportal zur Verfügung, über das
    Verträge verwaltet, Termine vereinbart, Support-Anliegen (Tickets) erstellt und Rechnungen
    abgerufen werden können.
  </p>
  <p>
    (2) Die Registrierung erfolgt über das auf der Website des Anbieters bereitgestellte Formular
    oder auf Einladung des Anbieters. Der Kunde hat bei der Registrierung wahrheitsgemäße Angaben zu
    machen und diese bei Änderungen unverzüglich zu aktualisieren.
  </p>
  <p>
    (3) Der Zugang zum Kundenportal ist durch individuelle Zugangsdaten geschützt. Der Kunde ist
    verpflichtet, seine Zugangsdaten geheim zu halten und vor dem Zugriff Dritter zu schützen, und
    hat den Anbieter unverzüglich zu informieren, wenn der Verdacht besteht, dass Unbefugte von den
    Zugangsdaten Kenntnis erlangt haben.
  </p>
  <p>
    (4) Die Nutzung des Kundenportals ist Bestandteil der Leistungserbringung und wird nicht
    gesondert vergütet.
  </p>
  <p>
    (5) Der Anbieter ist berechtigt, den Zugang zum Kundenportal bei berechtigtem Anlass –
    insbesondere bei einem Sicherheitsvorfall, bei Zahlungsverzug oder nach Vertragsende –
    vorübergehend oder dauerhaft zu sperren.
  </p>

  <h2>§5 Vor-Ort-Leistungen</h2>
  <p>
    (1) Vor-Ort-Leistungen sind optionale Leistungen, die leistungsbezogen gemäß §3 und dem Preis-
    und Leistungsverzeichnis vergütet werden.
  </p>
  <p>
    (2) Ob eine Vor-Ort-Leistung angeboten oder durchgeführt wird, liegt ausschließlich im freien
    Ermessen des Anbieters. Ein Anspruch des Kunden auf Vor-Ort-Leistungen besteht nicht, auch dann
    nicht, wenn eine Remote-Lösung technisch oder organisatorisch nicht möglich oder nicht sinnvoll
    erscheint.
  </p>
  <p>
    (3) Der Anbieter ist jederzeit berechtigt, Anfragen zu Vor-Ort-Leistungen ohne Angabe von
    Gründen abzulehnen und stattdessen ausschließlich Remote-Leistungen anzubieten oder den Auftrag
    insgesamt abzulehnen.
  </p>
  <p>
    (4) Vor-Ort-Leistungen werden – sofern vom Anbieter angeboten – ausschließlich innerhalb des vom
    Anbieter definierten Vor-Ort-Servicegebiets erbracht. Das Servicegebiet ergibt sich aus einer
    vom Anbieter veröffentlichten PLZ-Liste, die nicht Bestandteil dieser AGB ist.
  </p>

  <h2>§6 Softwareprodukte</h2>
  <p>
    (1) Der Anbieter bietet Softwareprodukte als eigenständig buchbare Leistungen an. Die aktuell
    angebotenen Produkte, ihre Entgelte und Abrechnungszeiträume ergeben sich aus dem Preis- und
    Leistungsverzeichnis; Leistungsumfang, Laufzeit, Kündigung sowie produktspezifische Regelungen
    ergeben sich aus den Besonderen Bedingungen des jeweiligen Produkts.
  </p>
  <p>
    (2) Sehen die Besonderen Bedingungen eines Produkts eine Ende-zu-Ende- oder
    Zero-Knowledge-Verschlüsselung vor, erhält und speichert der Anbieter ausschließlich
    verschlüsselte Daten und hat zu keinem Zeitpunkt Kenntnis vom Master-Passwort des Kunden oder
    von den unverschlüsselten Inhalten. Der Anbieter ist in diesem Fall bei Verlust des
    Master-Passworts oder sonstiger für die Entschlüsselung erforderlicher Zugangsdaten technisch
    nicht in der Lage, gespeicherte Inhalte wiederherzustellen. Der Kunde ist für die sichere
    Aufbewahrung seiner Zugangsdaten sowie für eigene, geeignete Vorkehrungen selbst verantwortlich.
  </p>
  <p>
    (3) Mit Beendigung eines Vertrags über ein Softwareprodukt wird der Zugang deaktiviert. Fristen
    für die endgültige Löschung gespeicherter Daten ergeben sich aus den Besonderen Bedingungen des
    jeweiligen Produkts; der Kunde ist selbst dafür verantwortlich, vor Vertragsende eine eigene
    Sicherung seiner Daten vorzunehmen, soweit er sie weiterhin benötigt.
  </p>

  <h2>§7 Termine &amp; Mitwirkungspflichten</h2>
  <p>(1) Vereinbarte Termine sind vom Kunden verbindlich einzuhalten.</p>
  <p>
    (2) Der Kunde ist verpflichtet, alle zur Leistungserbringung erforderlichen Mitwirkungen
    rechtzeitig zu erbringen, insbesondere: Bereitstellung notwendiger Zugänge, funktionsbereite
    Geräte, vollständige und zutreffende Informationen.
  </p>
  <p>
    (3) Verzögerungen oder Mehraufwand aufgrund fehlender oder unzureichender Mitwirkung des Kunden
    gehen nicht zu Lasten des Anbieters.
  </p>
  <p>
    (4) Der Anbieter haftet nicht für bereits bestehende Systemfehler oder Schäden, die unabhängig
    von der erbrachten Leistung auftreten.
  </p>

  <h2>§8 Haftung</h2>
  <p>
    (1) Der Anbieter haftet uneingeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei der
    Verletzung von Leben, Körper oder Gesundheit.
  </p>
  <p>
    (2) Bei einfacher Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher
    Vertragspflichten (Kardinalpflichten). In diesem Fall ist die Haftung auf den vorhersehbaren,
    vertragstypischen Schaden begrenzt.
  </p>
  <p>(3) Eine weitergehende Haftung auf Schadensersatz ist — soweit gesetzlich zulässig — ausgeschlossen.</p>
  <p>
    (4) Für Datenverluste haftet der Anbieter nur im Rahmen der vorstehenden Regelungen und nur,
    soweit der Kunde eine angemessene und regelmäßige Datensicherung durchgeführt hat.
  </p>
  <p>
    (5) Für Softwareprodukte mit Zero-Knowledge-Verschlüsselung (§6 Abs. 2) gilt ergänzend: Eine
    Haftung des Anbieters für Datenverluste, die aus der fehlenden Wiederherstellbarkeit bei Verlust
    der für die Entschlüsselung erforderlichen Zugangsdaten resultieren, ist ausgeschlossen, soweit
    der Verlust nicht auf einer vom Anbieter zu vertretenden Pflichtverletzung beruht, etwa einer
    unzureichenden Datensicherung auf Seiten des Anbieters.
  </p>
  <p>(6) Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.</p>
  <p>(7) Der Kunde ist verpflichtet, vor Beginn der Fernwartung eine Datensicherung durchzuführen.</p>
  <p>
    (8) Der Anbieter haftet nicht für indirekte Schäden, entgangenen Gewinn oder
    Produktionsausfälle, soweit gesetzlich zulässig.
  </p>
  <p>
    (9) Der Kunde trägt die Verantwortung für die Rechtmäßigkeit der auf seinen Systemen sowie der
    in Softwareprodukten des Anbieters gespeicherten Inhalte.
  </p>
  <p>
    (10) Sehen die Besonderen Bedingungen eines Softwareprodukts einen Notfallzugang für eine vom
    Kunden benannte Vertrauensperson vor, haftet der Anbieter nicht dafür, dass die Vertrauensperson
    oder der Kunde selbst die hierzu versendeten Mitteilungen (insbesondere zur Anforderung des
    Zugangs oder zum möglichen Widerspruch) zur Kenntnis nimmt oder rechtzeitig reagiert. Der
    Anbieter schuldet insoweit ausschließlich den Versand der jeweiligen Mitteilung, nicht deren
    Kenntnisnahme.
  </p>

  <h2>§9 Zahlung und Verzug</h2>
  <p>
    (1) Alle Entgelte verstehen sich inklusive der gesetzlichen Mehrwertsteuer, sofern diese
    anfällt; maßgeblich ist das Preis- und Leistungsverzeichnis.
  </p>
  <p>
    (2) Rechnungen sind innerhalb der angegebenen Zahlungsfrist zu begleichen. Gerät der Kunde in
    Verzug, ist der Anbieter berechtigt, gesetzliche Verzugszinsen zu verlangen.
  </p>
  <p>
    (3) Bei Zahlungsverzug oder fehlgeschlagener Abbuchung ist der Anbieter berechtigt, Leistungen
    bis zum vollständigen Zahlungsausgleich auszusetzen; dies umfasst auch den Zugang zu
    Softwareprodukten.
  </p>
  <p>
    (4) Soweit für ein Softwareprodukt oder eine sonstige Leistung eine automatisierte Zahlung über
    einen Zahlungsdienstleister vereinbart ist, erfolgt die Abbuchung über den vom Kunden gewählten
    Zahlungsdienstleister; im Übrigen erfolgt die Zahlung per Rechnung.
  </p>

  <h2>§10 Vertragslaufzeit und Kündigung</h2>
  <p>
    (1) Leistungsbezogen abgerechnete IT-Dienstleistungen (§3) begründen kein Dauerschuldverhältnis;
    es bestehen keine Laufzeiten oder Kündigungsfristen.
  </p>
  <p>
    (2) Laufzeit, Abrechnungszeitraum und Kündigung von Verträgen über Softwareprodukte ergeben sich
    aus den Besonderen Bedingungen des jeweiligen Produkts. Enthalten diese keine Regelung, läuft
    der Vertrag auf unbestimmte Zeit und kann jederzeit zum Ende des laufenden Abrechnungszeitraums
    gekündigt werden.
  </p>
  <p>
    (3) Die Kündigung kann unkompliziert über das bereitgestellte Kundenportal oder per E-Mail an
    den Anbieter erfolgen.
  </p>
  <p>(4) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.</p>
  <p>
    (5) Mit Beendigung eines Vertrags über ein Softwareprodukt gelten ergänzend die Löschfristen der
    jeweiligen Besonderen Bedingungen (§6 Abs. 3).
  </p>

  <h2>§11 Widerrufsrecht (für Verbraucher)</h2>
  <p>
    (1) Verbrauchern steht bei Fernabsatz- oder außerhalb von Geschäftsräumen geschlossenen
    Verträgen ein gesetzliches Widerrufsrecht zu. Die Einzelheiten ergeben sich aus der gesonderten
    Widerrufsbelehrung.
  </p>
  <p>
    (2) Bei Buchungen im Kundenportal, deren Ausführung unmittelbar mit Vertragsschluss beginnt,
    holt der Anbieter vor Auslösen der kostenpflichtigen Bestellung die nach § 356 Abs. 4 BGB
    erforderliche ausdrückliche Zustimmung des Kunden zum vorzeitigen Beginn der Vertragsausführung
    sowie dessen Bestätigung der Kenntnis vom Verlust des Widerrufsrechts bei vollständiger
    Vertragserfüllung gesondert ein. Die Bestellung ist ohne diese Zustimmung technisch nicht
    auslösbar.
  </p>
  <p>
    (3) Die Zustimmung nach Abs. 2 wird zu Nachweiszwecken mit Zeitpunkt protokolliert (siehe
    Datenschutzerklärung, Abschnitt „Zustimmung zum vorzeitigen Vertragsbeginn").
  </p>

  <h2>§12 Datenschutz</h2>
  <p>
    Die Verarbeitung personenbezogener Daten erfolgt gemäß der Datenschutzerklärung des Anbieters
    und den geltenden Datenschutzgesetzen.
  </p>

  <h2>§13 Schlussbestimmungen</h2>
  <p>(1) Es gilt das Recht der Bundesrepublik Deutschland.</p>
  <p>
    (2) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit
    der übrigen Regelungen unberührt.
  </p>
  <p>(3) Gerichtsstand ist — soweit gesetzlich zulässig — der Sitz des Anbieters.</p>
  <p>
    (4) Für Verträge, die vor dem 21.08.2026 geschlossen wurden, gelten die bei Vertragsschluss
    einbezogenen Allgemeinen Geschäftsbedingungen (zuletzt Fassung 2.7 vom 21.08.2026) unverändert
    fort. Der Anbieter stellt dem Kunden die für seinen Vertrag maßgebliche Fassung auf Anfrage
    zur Verfügung.
  </p>

  <p class="stand">
    Stand: 21.08.2026 · Version 3.0<br />
    Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge, die ab dem oben genannten Datum
    geschlossen werden. Sie lösen die bisherige Fassung 2.7 vom 21.08.2026 ab.
  </p>
</div>
